import axios from 'axios'
import appConfig from '../configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from '../constants/api.constant'
import { PERSIST_STORE_NAME } from '../constants/app.constant'
import deepParseJson from '../utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'
import {showNotification} from "@mantine/notifications";

const unauthorizedCode = [401]

const BaseService = axios.create({
    timeout: 60000,
    baseURL: appConfig.liveApiUrl,
})

BaseService.interceptors.request.use(
    (config) => {
        const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
        const persistData = deepParseJson(rawPersistData)
        // const accessToken = persistData.auth?.session.token
        // console.log(accessToken)
        const accessToken = persistData.auth?.session.token
        // const xWpNonce = persistData.auth?.session.xWpNonce
        // console.log(xWpNonce)
        /*if (xWpNonce) {
            config.headers['X-WP-Nonce'] = xWpNonce
        }*/
        if (accessToken) {
            config.headers[
                REQUEST_HEADER_AUTH_KEY
            ] = `${TOKEN_TYPE}${accessToken}`
        }

        return config
    },
    (error) => {
        store.dispatch(onSignOutSuccess())
        return Promise.reject(error)
    }
)

BaseService.interceptors.response.use(
    (response) =>{
       return  response
    },
    (error) => {
        const { response } = error
        switch (response.status) {

            case 401: {
                // store.dispatch(onSignOutSuccess())
                // window.location = `${appLocalizer?.homeUrl}/lazytasks/#/dashboard`;
                showNotification({
                    title: 'Error',
                    message: response.data.message || 'Unauthorized access. Please log in again.',
                    color: 'red',
                })
                return Promise.reject(error)
            }

            // forbidden (permission related issues)
            case 403: {
                if(response.data.message ==='Expired token' || response.data.message === 'Token has expired'){
                    store.dispatch(onSignOutSuccess())
                    window.location = `${appLocalizer?.homeUrl}/lazytasks/#/lazy-login`;
                    return Promise.reject(error)
                    }
                //show notification
                showNotification({
                    title: 'Error',
                    message: response.data.message || 'You do not have permission to perform this action.',
                    color: 'red',
                })
                return Promise.reject(error.response.data)
            }
            // expired token
            case 408: {
                store.dispatch(onSignOutSuccess())
                window.location = `${appLocalizer?.homeUrl}/lazytasks/#/lazy-login`;
                return Promise.reject(error.response.data)
            }

            // bad request
            case 400: {
                // store.dispatch(onSignOutSuccess())
                showNotification({
                    title: 'Error',
                    message: response.data.message || 'Bad request.',
                    color: 'red',
                })
                return Promise.reject(error)
            }

            // not found
            case 404: {
                // store.dispatch(onSignOutSuccess())
                showNotification({
                    title: 'Error',
                    message: response.data.message || 'The requested resource was not found.',
                    color: 'red',
                })
                return Promise.reject(error)
            }

            // conflict
            case 498: {
                store.dispatch(onSignOutSuccess())
                return Promise.reject(error)
            }

            // unprocessable
            case 422: {
                store.dispatch(onSignOutSuccess())
                return Promise.reject(error)
            }
            default: {
                // store.dispatch(onSignOutSuccess())
                return Promise.reject(error)
                // return Promise.reject(new APIError(err.message, 500));
            }
        }

    }
)

export default BaseService
